import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import routes from '../router/routes-config';
import { currentLang } from '../../../utils/lang';
import { setCanonicalUrl, setDocumentTitle, setMetaDescription } from '../../../utils/meta';
import { absoluteUrl, basePath, localizedBasePaths, setAlternateUrls, updateLanguageSwitchers, routeConfigByUrl, getParamsFromUrl, } from '../../../utils/router';
import { useCurrentPath } from '../hooks/router';
import { getReactElement } from '../utils/element';
const MapContent = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const currentPath = useCurrentPath();
    useEffect(() => {
        const routeConfig = routeConfigByUrl(currentPath);
        const reactElement = getReactElement();
        if (routeConfig?.meta && !routeConfig.meta.isTranslationWithParameters) {
            setDocumentTitle(t(routeConfig.meta.title));
            setMetaDescription(t(routeConfig.meta.description));
            setCanonicalUrl(absoluteUrl(basePath(reactElement) + location.pathname));
        }
        if (routeConfig) {
            const basePaths = localizedBasePaths(reactElement);
            const routeParameters = getParamsFromUrl(routeConfig.path[currentLang()], location.pathname);
            setAlternateUrls(routeConfig, basePaths, routeParameters);
            updateLanguageSwitchers(routeConfig, basePaths, routeParameters);
        }
    }, [location]);
    return (_jsx(Routes, { children: routes.map((route, i) => (_jsx(Route, { path: route.path[currentLang()], Component: route.component }, i))) }));
};
export default MapContent;
